import { render, staticRenderFns } from "./overviewConnectCard.vue?vue&type=template&id=7229c6c4&scoped=true&"
import script from "./overviewConnectCard.vue?vue&type=script&lang=js&"
export * from "./overviewConnectCard.vue?vue&type=script&lang=js&"
import style0 from "./overviewConnectCard.vue?vue&type=style&index=0&id=7229c6c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7229c6c4",
  null
  
)

export default component.exports